export function getAbsPosition (el) {
  let el2 = el;
  let curtop = 0;
  let curleft = 0;
  if (document.getElementById || document.all) {
    do {
      curleft += el.offsetLeft - el.scrollLeft;
      curtop += el.offsetTop - el.scrollTop;
      el = el.offsetParent;
      el2 = el2.parentNode;
      while (el2 != el) {
        curleft -= el2.scrollLeft;
        curtop -= el2.scrollTop;
        el2 = el2.parentNode;
      }
    } while (el && el.offsetParent);
  } else if (document.layers) {
    curtop += el.y;
    curleft += el.x;
  }
  return {
    top: curtop,
    left: curleft,
  };
}

export const isIE = !!document.documentElement.currentStyle;

function isOffsetRoot (el) {
  if (isIE) {
    return false;
  }

  return window.getComputedStyle(el).getPropertyValue('transform') != 'none';
}

export function getOffsetPostion (el) {
  let left = 0;
  let top = 0;
  while (el && !isOffsetRoot(el)) {
    left += el.offsetLeft;
    top += el.offsetTop;

    el = el.offsetParent;
  }

  return {
    left,
    top,
  };
}

export function getScrollParent (node) {
  if (node == null) {
    return null;
  }

  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getScrollParent(node.parentNode);
  }
}

export const isDescendant = (parent, child) => {
  let node = child.parentNode;
  while (node !== null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};
